import { connect } from 'react-redux';
import { memberStatus as memberStatusSelector } from 'redux/saga/selectors/user';
import { showModal } from 'redux/modules/modals';
import { reservationStatusChanged } from 'features/Reservation/Reservation.saga';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { deepExtract } from 'helpers/deep';
import { isLoggedIn } from 'redux/modules/user';
import { selectMediaState, selectIsMobile } from 'redux/modules/device';
import { showAllVenues, loadPage } from './search.saga';
import { SearchResults } from './components/SearchResults';
import {
  selectSchedulesInLayout,
  selectShouldShowMap,
  selectVenuesInLayout,
  selectCursorInLayout,
  selectErrorInLayout,
  selectResultsLayout,
  selectRelatedFiltersInLayout,
  getUserLocationForSearch,
} from './Search.helpers';
import { FILTER_NAMES, RESULT_TYPES } from './Search.constants';
import { selectCurrentPage, selectSearchId, selectIsMapToggleable, selectVisibleVenues } from './Search.reducer';
import { DEFAULT_RESULT_TYPE_LOGGED_IN } from './filters/filters.saga';
import { unhighlightVenue, highlightVenue } from './Map/SearchMap.reducer';
import { selectSelectedVertical } from './filters/filters.helpers';

export const mapStateToProps = state => {
  const currentPage = selectCurrentPage(state);
  const searchId = selectSearchId(state);
  const { data: searchData, error, loaded, loading } = selectResultsLayout(state);
  const filters = filterSetFilters(state, SEARCH);
  const resultType = deepExtract(`${FILTER_NAMES.RESULT_TYPE}.value`, filters, DEFAULT_RESULT_TYPE_LOGGED_IN);
  const currentVertical = selectSelectedVertical(state);
  const searchResultError = selectErrorInLayout(searchData);
  const isError = (!!error || !!searchResultError) && !loading;

  let results;
  let shouldShowSeeAllVenuesLink;
  if (resultType === RESULT_TYPES.SCHEDULE) {
    results = selectSchedulesInLayout(searchData);
  } else {
    const visibleVenues = selectVisibleVenues(state);
    const allVenues = selectVenuesInLayout(searchData);
    if (visibleVenues && allVenues) {
      shouldShowSeeAllVenuesLink = visibleVenues.length < allVenues.length;
    }
    results = visibleVenues;
  }
  const mediaState = selectMediaState(state);
  const relatedFilters = selectRelatedFiltersInLayout(searchData);
  const { locations: relatedLocationFilters, activities: relatedActivityFilters } = relatedFilters;
  const { locationName, isMapSearch } = getUserLocationForSearch(state);

  return {
    currentPage,
    currentVertical,
    hasNextPage: !!selectCursorInLayout(searchData),
    isViewingNextCycle: state.user.viewingNextCycle,
    isLoading: !!loading,
    isLoaded: !!loaded,
    memberStatus: memberStatusSelector(state),
    isLoggedIn: isLoggedIn(state),
    isMobile: selectIsMobile(state),
    isMapToggleable: selectIsMapToggleable(state),
    showMap: selectShouldShowMap(state),
    shouldShowShortDescription: mediaState.lg && !mediaState.xl,
    shouldShowSeeAllVenuesLink,
    searchId,
    results,
    resultType,
    isError,
    relatedLocationFilters,
    relatedActivityFilters,
    locationName: !isMapSearch ? locationName : undefined,
  };
};

export const mapDispatchToProps = {
  showAllVenues,
  showModal,
  reservationStatusChanged,
  onLoadNextPage: loadPage.bind(null, 1),
  onLoadPreviousPage: loadPage.bind(null, -1),
  onListItemEnter: highlightVenue,
  onListItemLeave: unhighlightVenue,
};

export const SearchResultsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);
